import { createContext } from "react";

import type { CuratedPlaceOfSafetyUnbranded } from "@thalamos/common";
import type {
  DataSharingPartnershipWithDataControllersUnbranded,
  ExtendedThalamosUser,
  ManagedLocation,
  NotificationsResponse,
  TrustUnbranded,
} from "@thalamos/aspire-common";

const emptyNotificationsContext = {
  notifications: { notifications: [], unviewedCount: 0, count: 0 },
  notificationsPage: 0,
  setNotificationsPage: () => {},
};

export const NotificationsContext = createContext<{
  notifications: NotificationsResponse;
  notificationsPage: number;
  setNotificationsPage: (n: number) => void;
}>(emptyNotificationsContext);

export const LoggedInUserContext = createContext<{
  user: ExtendedThalamosUser;
  refetchUser: () => void;
} | null>(null);

export interface EmailRedirectEntry {
  sourceEmail: string;
  targetTeamId: string;
  targetTeamName: string | null;
  message: string | null;
}

export const ManagedLocationsContext = createContext<{
  managedLocations: ManagedLocation[];
  trusts: TrustUnbranded[];
  curatedPlacesOfSafety: CuratedPlaceOfSafetyUnbranded[];
  dataSharingPartnerships: DataSharingPartnershipWithDataControllersUnbranded[];
  emailRedirects: EmailRedirectEntry[];
  refetchManagedLocations: () => void;
}>({
  managedLocations: [],
  trusts: [],
  curatedPlacesOfSafety: [],
  dataSharingPartnerships: [],
  emailRedirects: [],
  refetchManagedLocations: () => {},
});
